export default "__VITE_ASSET__BiUlWA$A__"